<template>
  <div>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data: function () {
    return {
    }
  },
  async created() {
    const loginRes = await this.$faApi.isLogin()
      if (loginRes.userId) {
        // 如果没有登录，或者accessToken失效，去登录
        this.$router.push({ path: `/user/${loginRes.userId}/joined_groups` })
        return
      } else {
        this.goToLogin();
      } 
  },
  methods: {
    goToSignup() {
      this.$router.push({ path: '/signup' })
    },
    goToLogin() {
      this.$router.push({ path: '/login_sms' })
    },
    goToPlanB() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>

<style scoped lang="scss">
  

</style>
  